import axiosClient from "../../../../system/helpers/axiosConfig";
export const getChat = (id) => {
  return axiosClient.get(`/api/im/view/${id}`).then((r) => r.data);
};
